import { ChangeEvent, SyntheticEvent, useCallback, useState } from 'react';
import { getApiUrl } from '../api';
import { Photo, categories } from '../models_generated';
import { ROUTES } from '../routes';
import { useAsyncEffect } from '../utils/hooks';
import { BaseView } from './BaseView';
import { ReactMarkdown } from 'react-markdown/lib/react-markdown';
import { Link } from 'react-router-dom';
import { API_STORE } from '../ApiStore';

const DEFAULT_MAX = 25;

export function PhotosPage() {
	const params = new URLSearchParams(window.location.search);
	let [photos, setPhotos] = useState(undefined as (Photo & {randomStr?: string})[] | undefined);
	let [max, setMax] = useState(DEFAULT_MAX);
	let [search, setSearch] = useState(params.get("q") || "");
	let [random, setRandom] = useState(false);
	let [searchType, setSearchType] = useState(undefined as "categories" | "owners" | undefined);

	useAsyncEffect(async () => {
		try {
			const resp = await fetch(getApiUrl("/photos"), { method: "get", mode: "cors" })
			setPhotos((await resp.json()) as any[])
		} catch (e) {
			alert(e);
		}
	}, [])

	const onSeach = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
		setSearch(e.target.value)
	}, [search]);
	const onRandomPhoto = useCallback(() => {
		if (!photos) {
			return;
		}
		const rndPhotoIndex = Math.floor(Math.random()*photos?.length)
		const photo = photos?.[rndPhotoIndex];
		setSearch("id:" + photo?.id);
	}, [photos]);
	const onLoadMOre = () => {
		setMax(max + DEFAULT_MAX);
	};

	const onToggleRandom = () => {
		random = !random
		setRandom(random);
		for (const p of (photos || [])) {
			p.randomStr = random ? "" + Math.random() : undefined;
		}
	}

	if (!photos) {
		return <h1>Loading...</h1>;
	}

	const getOrderStr = (p1: Photo) => ((p1 as any)?.randomStr || ("00000000" + (100000 - p1.id)).slice(-6) || "x");

	let filteredPhotos = photos?.slice()?.sort((p1, p2) => getOrderStr(p1).localeCompare(getOrderStr(p2))).filter(p => {
		if (!search) {
			return true;
		} else if (search.startsWith("todo:")) {
			return !!p.todo;
		} else if (search.startsWith("id:")) {
			const id = parseInt(search.replace("id:", ""));
			return p.id == id;
		} else if (search.startsWith("owner:")) {
			const owner = search.replace("owner:", "")
			return p.owner?.toLowerCase().indexOf(owner.toLocaleLowerCase()) >= 0;
		} else if (search.startsWith("category:")) {
			const category = search.replace("category:", "")
			return p.category?.toLowerCase() == category.toLocaleLowerCase();
		} else {
			const txt = (p.owner + " " + p.name + " " + p.description + " " + p.keywords + " " + p.date).toLowerCase();
			console.log(search + "..." + txt)
			return txt.indexOf(search.toLocaleLowerCase()) >= 0;
		}
	})

	const owners = [] as string[];
	for (const photo of photos) {
		if (photo.owner && owners.indexOf(photo.owner) < 0) {
			owners.push(photo.owner);
		}
	}
	owners.sort();

	return <BaseView>
		<h1>Fotografije</h1>
		<p>
			Pretraživanje:
			<input type='text' style={{width: "100%"}} onChange={onSeach} value={search} />
			<button onClick={onToggleRandom}>{random ? "Normal order" : "Randomize"}</button>
			&nbsp;
			<button onClick={() => setSearchType("owners")}>Spisak vlasnika</button>
			&nbsp;
			<button onClick={() => setSearchType("categories")}>Spisak kategorija</button>
			&nbsp;
			<button onClick={() => setSearch("todo:")}>TODOs</button>
			&nbsp;
		</p>
		{!!searchType && <>
			{searchType == "categories" && <>
				<h2>Kategorije:</h2>
				{categories.map((c, index) => <>
					{index > 0 && <>&middot;</>}
					[<a href={ROUTES.PHOTOS.url() + "?q=category:" + encodeURIComponent(c.id)}>{c.description}</a>]
				</>)}
			</>}
			{searchType == "owners" && <>
				<h2>Vlasnici fotografija</h2>
				{owners.map((o, index) => <>
					{index > 0 && <>&middot;</>}
					[<a href={ROUTES.PHOTOS.url() + "?q=owner:" + encodeURIComponent(o)}>{o}</a>]
				</>)}
			</>}
		</>}
		<hr/>
		{filteredPhotos?.map((photo, index) => (index < max) ? <PhotoDetails photo={photo} /> : undefined)}
		<hr/>
		{!!(max < filteredPhotos?.length) && <button onClick={onLoadMOre}>Load more</button>}
	</BaseView>;
}

function PhotoDetails(props: { photo: Photo }) {
	const [photo, setPhoto] = useState(props.photo);
	const onUpdatePublish = async () => {
		debugger;
		try {
			const resp = await API_STORE.doFetch("post", `/photo/${photo.id}/field/publish`, {jsonBody: {value: !photo.publish}});
			setPhoto(resp);
		} catch (e) {
			API_STORE.alertError(e);
		}
	}
	const onEditTODO = async () => {
		debugger;
		try {
			let todo = window.prompt("Zadatak:", photo.todo);
			if (!todo) {
				todo = "";
			}
			if (window.confirm(`Da li ste sigurni da želite da promenite zadatak "${todo}"?`)) {
				const resp = await API_STORE.doFetch("post", `/photo/${photo.id}/field/todo`, {jsonBody: {value: todo}});
				setPhoto(resp);
			}
		} catch (e) {
			API_STORE.alertError(e);
		}
	}
	return (
		<p>
			&nbsp;
			<a href={ROUTES.PHOTO.url(photo.id)}>{photo.name || "Bez naziva"}</a>
			<br/>
			<button onClick={onUpdatePublish}>{photo.publish ? "Objavljeno" : "Nije objavljeno"}</button>
			<button onClick={onEditTODO}>Zadatak: {photo.todo || "-"}</button>
			<br/>
			{photo.category && <><small>Kategorija: {photo.category}</small><br/></>}
			{photo.owner && <><small>Vlasnik: {photo.owner}</small><br/></>}
			{photo.keywords && <><small>Ključne riječi: {photo.keywords}</small><br/></>}
			<br/>
			{photo?.image && <img src={photo.thumbnail + "?=" + Math.random()} style={{ width: "200px", float: "left" }} />}
			{photo.description && <div style={{float: 'left'}}><ReactMarkdown children={photo.description} /></div>}
			<div style={{clear: "both"}}></div>
			<hr />
		</p>
	);
}
